/* eslint react/jsx-props-no-spreading: 0 */
import PropTypes from 'prop-types';
import { Field, ErrorMessage } from 'formik';

import { Fragment } from 'react';
import checkedImg from '../../assets/svg/checkbox-checked.svg';
import uncheckedImg from '../../assets/svg/checkbox-unchecked.svg';
import TextError from './TextError';

const CheckboxGroup = (props) => {
  const {
    label, name, options, ...rest
  } = props;
  return (
    <div className="flex flex-col justify-center gap-2">
      <label
        className="rounded-t-xl bg-white px-1 text-lg text-pj-gray-800 duration-300"
        htmlFor={name}
      >
        {label}
      </label>
      <Field name={name} id={name}>
        {({ field }) => options.map((option) => (
          <Fragment key={option.key}>
            <input
              className="hidden"
              type="checkbox"
              id={option.value}
              {...field}
              {...rest}
              value={option.value}
              checked={field.value.includes(option.value)}
            />

            <label className="flex gap-1" htmlFor={option.value}>
              <span className="w-8">
                {field.value.includes(option.value) ? (
                  <img
                    src={checkedImg}
                    alt={`Checked checkbox for ${name}`}
                  />
                ) : (
                  <img
                    src={uncheckedImg}
                    alt={`Unchecked checkbox for ${name}`}
                  />
                )}
              </span>
              <span>{option.key}</span>
            </label>
          </Fragment>
        ))}
      </Field>
      <ErrorMessage component={TextError} name={name} />
    </div>
  );
};

CheckboxGroup.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default CheckboxGroup;
